// extracted by mini-css-extract-plugin
module.exports = {"expanderWrapper":"Expander_expanderWrapper__rhq9S","expanderHeader":"Expander_expanderHeader__7CXbw"};